import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { environment } from 'environments/environment';
import { getSentryConfig } from 'app/core/sentry/config/sentry.config';
import { configureSentryUserFromLocalStorage } from 'app/core/sentry/config/sentry.user-config';

if (environment.enableSentry) {
  Sentry.init(getSentryConfig());

  // Set custom tags with exact property names from environment
  Sentry.setTag('clientName', environment.clientName);
  Sentry.setTag('appEnvironment', environment.sentryEnvironment);
  Sentry.setTag('appVersion', environment.appVersion);

  configureSentryUserFromLocalStorage();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  if (environment.enableSentry) {
    Sentry.captureException(err);
  }
});
